import React from "react";
import DetalhesRequisitosLegais from "./DetalhesRequisitosLegais";

export default function CadastroRequisitosLegais() {
  return <DetalhesRequisitosLegais />;
}
